import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './zh-CN.js'
import en from './en.js'

Vue.use(VueI18n)

// 检测浏览器语言
const getBrowserLanguage = () => {
  const language = navigator.language || navigator.userLanguage
  if (language.startsWith('zh')) {
    return 'zh'
  } else {
    return 'en'
  }
}

// 从localStorage获取语言设置
const getLocalLanguage = () => {
  return localStorage.getItem('language') || getBrowserLanguage()
}

// 创建i18n实例
const i18n = new VueI18n({
  locale: getLocalLanguage(),
  messages: {
    'zh': zhCN, // 使用zh作为key以保持与现有代码兼容
    'en': en
  },
  // 设置语言回退机制
  fallbackLocale: 'zh',
  // 关闭控制台警告
  silentTranslationWarn: true
})

// 切换语言的方法
export const switchLanguage = (language) => {
  i18n.locale = language
  localStorage.setItem('language', language)
}

export default i18n